import { HTMLAttributes } from "react"

type InfoCircleProps = HTMLAttributes<SVGElement> & {
  size?: string
  color?: string
}

export const InfoCircle = ({ size = "16px", color, ...props }: InfoCircleProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 1.33325C6.68144 1.33325 5.39251 1.72425 4.29618 2.45679C3.19985 3.18933 2.34537 4.23052 1.84079 5.4487C1.3362 6.66687 1.20418 8.00731 1.46141 9.30052C1.71865 10.5937 2.35359 11.7816 3.28594 12.714C4.21829 13.6463 5.40617 14.2813 6.69938 14.5385C7.99259 14.7957 9.33303 14.6637 10.5512 14.1591C11.7694 13.6545 12.8106 12.8 13.5431 11.7037C14.2757 10.6074 14.6666 9.31846 14.6666 7.99992C14.6647 6.23241 13.9617 4.53786 12.7119 3.28804C11.462 2.03823 9.76749 1.33522 7.99998 1.33325ZM7.1629 5.83398C7.1629 5.37375 7.536 5.00065 7.99624 5.00065C8.45647 5.00065 8.82957 5.37375 8.82957 5.83398C8.82957 6.29422 8.45647 6.66732 7.99624 6.66732C7.536 6.66732 7.1629 6.29422 7.1629 5.83398ZM7.32957 8.33252C7.32957 7.96433 7.62805 7.66585 7.99624 7.66585C8.36443 7.66585 8.6629 7.96433 8.6629 8.33252V10.3325C8.6629 10.7007 8.36443 10.9992 7.99624 10.9992C7.62805 10.9992 7.32957 10.7007 7.32957 10.3325V8.33252Z"
        fill={color ?? "currentColor"}
      />
    </svg>
  )
}
